import React from "react";

import Dropzone, { IDropzoneProps, IFileWithMeta } from "../../Dropzone/Dropzone";
import Label from "../Label/Label";

//TODO: create image preview component for dropzone
// const ImagePreview = (props: IPreviewProps) => {

//   return (
//     <CustomCarousel ImageUrls={props.files.map(i => i.meta!.previewUrl!)} />
//   )
// }

export interface CustomDropzoneProps extends Partial<IDropzoneProps> {
  IsRequired?: boolean;
  labelText: string;
  onValueChange: (e: IFileWithMeta, s: string, value: IFileWithMeta[]) => void,
  acceptFileTypes: string,
  accept?: string
}

export default function CustomDropzone(props: CustomDropzoneProps) {
  //const classes = useStyles();
  const {
    labelText,
    IsRequired,
    maxSizeBytes,
    onValueChange,
    inputContent,
    acceptFileTypes,
    ...rest
  } = props;

  var tempInputContent: React.ReactNode = "Drop or click to add files";
  if (inputContent) {
    tempInputContent = inputContent;
  }

  var tempMaxSizeBytes = 20971520;
  if (maxSizeBytes) {
    tempMaxSizeBytes = maxSizeBytes;
  }



  return (
    <div>
      <Label labelText={labelText} IsRequired={IsRequired}></Label>
      <Dropzone
        onChangeStatus={onValueChange}
        maxSizeBytes={tempMaxSizeBytes}
        inputContent={tempInputContent}
        accept={acceptFileTypes}

        {...rest}
      />
    </div>
  )
}


